import {
    DayPicker,
    type DateRange,
    type DayPickerProps,
    type Formatters,
} from 'react-day-picker';
import {
    calendarClassNames,
    calendarComponents,
    selectedDayClass,
} from './calendarStyles';

interface RangeCalendarProps {
    disabled?: DayPickerProps['disabled'];
    startMonth?: DayPickerProps['startMonth'];
    endMonth?: DayPickerProps['endMonth'];
    selected: DateRange | undefined;
    onSelect: (range: DateRange | undefined, triggerDate: Date) => void;
    month: Date;
    onMonthChange: DayPickerProps['onMonthChange'];
    formatWeekdayName: Formatters['formatWeekdayName'];
}

export function RangeCalendar({
    selected,
    onSelect,
    month,
    onMonthChange,
    disabled,
    startMonth,
    endMonth,
    formatWeekdayName,
}: RangeCalendarProps) {
    return (
        <DayPicker
            mode="range"
            showOutsideDays
            disabled={disabled}
            startMonth={startMonth}
            endMonth={endMonth}
            selected={selected}
            onSelect={onSelect}
            modifiers={{
                range_start_pending:
                    selected?.from && !selected.to ? selected.from : false,
            }}
            modifiersClassNames={{ range_start_pending: selectedDayClass }}
            month={month}
            onMonthChange={onMonthChange}
            components={calendarComponents}
            formatters={{
                formatWeekdayName,
            }}
            classNames={{
                ...calendarClassNames,
                range_start: selectedDayClass,
                range_end: selectedDayClass,
                range_middle: '!bg-grey-550 !text-white-100',
            }}
        />
    );
}
